import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Legal.module.css';
import SEO from '../components/SEO';
import ObfuscatedEmail from '../components/ObfuscatedEmail';

const Legal = () => {
  return (
    <div className={styles.legalPage}>
      <SEO
        title="Legal Information"
        description="Legal information, licensing, and accreditation details for All For You Home Health Care. Licensed California home health agency, ACHC accredited."
        keywords="legal, licensing, accreditation, ACHC, California home health license, non-discrimination policy"
        canonicalUrl="https://allforyouhc.com/legal"
      />
      <div className={styles.container}>
        <div className={styles.header}>
          <h1>Legal</h1>
          <p>Last updated: January 2024</p>
        </div>

        <div className={styles.legalGrid}>
          <Link to="/privacy-policy" className={styles.legalCard}>
            <h2>Privacy Policy</h2>
            <p>Learn about how we collect, use, and protect your personal information.</p>
            <span className={styles.arrow}>→</span>
          </Link>
        </div>

        <div className={styles.content}>
          <section className={styles.section}>
            <h2>Company Information</h2>
            <p><strong>All For You Home Home Health Care</strong></p>
            <p>40 N. Altadena Dr. Ste 200J</p>
            <p>Pasadena, CA 91107</p>
            <p>Phone: (818) 949-1031</p>
            <p>Fax: (818) 949-1032</p>
            <p>Email: <ObfuscatedEmail plain /></p>
          </section>

          <section className={styles.section}>
            <h2>Licensing & Accreditation</h2>
            <p>All For You Home Home Health Care is a licensed Home Health Care Agency in California, accredited by ACHC (Accreditation Commission for Health Care).</p>
            <p>We maintain all required state and federal certifications to provide quality home health care services.</p>
          </section>

          <section className={styles.section}>
            <h2>HIPAA Compliance</h2>
            <p>All For You Home Home Health Care complies with the Health Insurance Portability and Accountability Act (HIPAA) of 1996 and is fully committed to maintaining strict safeguards to protect your personal health data. Any information provided to us is handled properly, treated as confidential, and managed in accordance with applicable federal and state privacy laws.</p>
          </section>

          <section className={styles.section}>
            <h2>Non-Discrimination Policy</h2>
            <p>All For You Home Home Health Care does not discriminate against any person on the basis of race, color, creed, religion, sex, sexual preference, national origin, disability, or age in admission, treatment or participation in its programs, services and activities, or in employment.</p>
          </section>

          <section className={styles.section}>
            <h2>Contact Us</h2>
            <p>If you have any questions about our legal policies or need additional information, please contact us:</p>
            <p>Phone: <a href="tel:8189491031">(818) 949-1031</a></p>
            <p>Fax: (818) 949-1032</p>
            <p>Email: <ObfuscatedEmail /></p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Legal;
